import { themeVariables } from "src/themeVariables";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0px !important;
  padding: 8px 12px !important;
  font-size: 1rem;
  color: ${themeVariables.ctaTextColor} !important;

  svg {
    animation: ${spin} 2s linear infinite;
    path {
      fill: ${themeVariables.ctaTextColor} !important;
    }
  }

  background-color: ${themeVariables.primaryCTA} !important;
  border: none !important;
  border-radius: 8px !important;
  cursor: not-allowed !important;

  p {
    margin: 0;
    padding: 0;
  }

  &:disabled {
    opacity: 0.6;
  }
`;
